export const MEANING_SECTION_CONTENT = {
    meaningSectionTitle: 'Ý nghĩa của một số hình xăm',
    meaningSectionText: 'Hình xăm không chỉ là những nét mực trên da, mà là câu chuyện riêng của mỗi khách hàng, là những mảnh ký ức, tâm tư được tôi chạm khắc bằng cả trái tim và tâm hồn qua từng mũi kim, nét mực.',
    meaningSectionSubText: 'Mỗi hình xăm – một câu chuyện',
}